<script setup lang="ts">
import { useSwiper } from 'swiper/vue'

defineProps({
  labelPrev: {
    type: String,
    default: 'Previous'
  },
  labelNext: {
    type: String,
    default: 'Next'
  }
})

const swiper = useSwiper()
const isPrevDisabled = computed(() => !swiper.value.params.loop && swiper.value.isBeginning)
const isNextDisabled = computed(() => !swiper.value.params.loop && swiper.value.isEnd)
</script>

<template>
  <div
    v-if="
      swiper.slides.length > Number(swiper.params.slidesPerView) ||
      swiper.params.slidesPerView === 'auto'
    "
    class="flex items-center gap-4"
  >
    <Button
      variant="unstyled"
      :is-disabled="isPrevDisabled"
      :disabled="isPrevDisabled"
      :title="labelPrev"
      :icon="{ name: 'arrow-left' }"
      class="transition-opacity hover:opacity-50"
      @click="swiper.slidePrev()"
    />
    <Button
      variant="unstyled"
      :is-disabled="isNextDisabled"
      :disabled="isNextDisabled"
      :title="labelNext"
      :icon="{ name: 'arrow-right' }"
      class="transition-opacity hover:opacity-50"
      @click="swiper.slideNext()"
    />
  </div>
</template>
